var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap justify-center my-10"},[_c('iframe',{attrs:{"width":"100%","height":"480","src":_vm.element.source,"frameborder":"0","allow":"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }